module.exports = __webpack_public_path__ + "img/form-bg.9ee960b9.png";